import React, { useState, useLayoutEffect } from "react";
import { debounce } from "lodash";

export default function useSize(width, height, id) {
  const [size, setSize] = useState({ width: width, height: height });

  var observer = new MutationObserver(checkResize);
 
  function checkResize(mutations) {
    var el = mutations[0].target;
    var w = el.clientWidth+ "px";
    var h = el.clientHeight+ "px";
   
    var isChange = mutations
      .map((m) => m.oldValue + "")
      .some(
        (prev) =>
          prev.indexOf("width: " + w ) == -1 ||
          prev.indexOf("height: " + h ) == -1
      );

    if (isChange) debouncedHandleResize(w, h);
  }

  const debouncedHandleResize = debounce(function handleResize(
    width,
    height
  ) {
    
    
    setSize({ width: width , height: height  });
  },
  100);


  useLayoutEffect(() => {
   
    var target = document.getElementById(id);
    if (observer && target) {
      observer.observe(target, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ["style"],
      });
      return () => observer.disconnect();
    }    
  });

  return [size.width,  size.height];
}
